type Envelope<T> = { data: T | null; error: { code: string; message: string; details?: unknown } | null };

export class ApiError extends Error {
  constructor(
    public code: string,
    message: string,
    public status: number,
    public details?: unknown,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}

async function request<T>(method: string, path: string, body?: unknown, opts?: RequestInit): Promise<T> {
  const isFormData = body instanceof FormData;
  const headers: Record<string, string> = {
    Accept: 'application/json',
    ...(opts?.headers as Record<string, string> | undefined),
  };
  if (body !== undefined && !isFormData) {
    headers['Content-Type'] = 'application/json';
  }
  const res = await fetch(path, {
    method,
    credentials: 'include',
    headers,
    body: body === undefined ? undefined : isFormData ? body : JSON.stringify(body),
    ...opts,
  });

  if (res.status === 204) return undefined as T;

  const text = await res.text();
  let parsed: Envelope<T>;
  try {
    parsed = text ? (JSON.parse(text) as Envelope<T>) : { data: null, error: null };
  } catch {
    throw new ApiError('PARSE_ERROR', 'risposta server non valida', res.status);
  }

  if (!res.ok || parsed.error) {
    const err = parsed.error ?? { code: 'HTTP_ERROR', message: `HTTP ${res.status}` };
    throw new ApiError(err.code, err.message, res.status, err.details);
  }
  return parsed.data as T;
}

export const api = {
  get: <T>(path: string) => request<T>('GET', path),
  post: <T>(path: string, body?: unknown) => request<T>('POST', path, body),
  patch: <T>(path: string, body?: unknown) => request<T>('PATCH', path, body),
  delete: <T = void>(path: string) => request<T>('DELETE', path),
  upload: <T>(path: string, form: FormData) => request<T>('POST', path, form),
};
